import styled from 'styled-components';
import { isMobile } from 'utils/is-mobile';

export const ConfirmationPopoverStyled = styled.div`
  width: ${isMobile() ? '264px' : '328px'};
  padding: 4px 0;
`;

export const MainSectionStyled = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 16px;
`;

export const MainSectionIconStyled = styled.div`
  width: 68px;
  min-width: 68px;
  height: 68px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--v3-black-4);
  & > div {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--v3-black-6);
    & path {
      fill: var(--v3-primary-6);
    }
  }
`;

export const MainSectionWrapperStyled = styled.div`
  width: 100%;
  padding-left: 8px;
`;

export const MainSectionTitleStyled = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: var(--v3-text-color);
  padding-bottom: 4px;
`;

export const MainSectionMessageStyled = styled.div`
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: var(--v3-text-color-secondary);
`;

export const CheckboxSectionWrapperStyled = styled.div`
  padding: 16px 0;
  border-top: 1px solid var(--v3-black-6);
`;

export const CheckboxSectionStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
`;

export const ButtonsSectionStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonWrapperStyled = styled.div`
  width: calc(50% - 4px);
`;
